(() => {
  if (customElements.get('inn-size-links')) return;

  const categories = [
    ['patike-za-fudbal', 'patike za fudbal', true],
    ['patike-za-kosarku', 'patike za košarku', true],
    ['kopacke', 'kopačke', true],
    ['donji-dio-trenerke', 'donje dijelove trenerke', false],
    ['ski-hlace', 'ski hlače', false],
    ['cizme', 'čizme', true],
    ['papuce-i-japanke', 'papuče i japanke', true],
    ['patike', 'patike', true],
    ['trenerke', 'trenerke', false],
    ['dukserice', 'dukserice', false],
    ['jakne', 'jakne', false],
    ['majice', 'majice', false],
    ['sorcevi', 'šorceve', false],
    ['tajice', 'tajice', false],
    ['prsluci', 'prsluke', false]
  ];

  const groups = {
    'za-muskarce': 'Za muškarce',
    'za-zene': 'Za žene',
    'za-djecu': 'Za djecu'
  };

  const plain = value =>
    String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();

  const category = product =>
    categories.find(c => product.collections.includes(c[0]));

  const sizeIndex = product =>
    product.options.findIndex(o =>
      /^(velicina|velicine|broj|size|sizes|shoe size|velicina obuce|velicina odjece)$/.test(
        plain(o)
      )
    );

  const numericSize = value => {
    let s = String(value)
      .trim()
      .replace(/,/g, '.')
      .replace(/(\d)([½⅓⅔¼¾])/g, '$1 $2');

    const fractions = {
      '½': 0.5,
      '⅓': 1 / 3,
      '⅔': 2 / 3,
      '¼': 0.25,
      '¾': 0.75
    };

    const m = s.match(
      /^(\d+)\s+(1\/2|1\/3|2\/3|1\/4|3\/4|[½⅓⅔¼¾])$/
    );

    if (m) {
      const f =
        fractions[m[2]] ??
        Number(m[2].split('/')[0]) /
          Number(m[2].split('/')[1]);

      return Number(m[1]) + f;
    }

    return /^\d+(\.\d+)?$/.test(s) ? Number(s) : NaN;
  };

  const sizeKey = value => {
    const n = numericSize(value);

    if (Number.isFinite(n)) {
      return 'n:' + n.toFixed(5);
    }

    const s = plain(value).replace(/\s+/g, '');

    return (
      {
        '2xs': 'xxs',
        '3xs': 'xxxs',
        '2xl': 'xxl',
        '3xl': 'xxxl',
        '4xl': 'xxxxl',
        '5xl': 'xxxxxl'
      }[s] || s
    );
  };

  const orderedSizes = values => {
    const order = [
      'xxxs', 'xxs', 'xs', 's', 'm', 'l',
      'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl'
    ];

    return [...values].sort((a, b) => {
      const x = numericSize(a);
      const y = numericSize(b);

      if (Number.isFinite(x) && Number.isFinite(y)) {
        return x - y;
      }

      const ax = order.indexOf(sizeKey(a));
      const by = order.indexOf(sizeKey(b));

      if (ax >= 0 && by >= 0) {
        return ax - by;
      }

      return String(a).localeCompare(
        String(b),
        'bs',
        { numeric: true }
      );
    });
  };

  const element = (tag, cls, text) => {
    const el = document.createElement(tag);

    if (cls) el.className = cls;
    if (text !== undefined) el.textContent = text;

    return el;
  };

  class SizeLinks extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      try {
        const p = JSON.parse(
          this.querySelector('script').textContent
        );

        const cat = category(p);
        const index = sizeIndex(p);

        const audience = Object.keys(groups).filter(g =>
          p.tags.map(plain).includes(g)
        );

        if (!cat || index < 0 || !audience.length) return;

        const sizes = new Map();

        p.variants.forEach(v => {
          const label = v.options[index];
          const key = sizeKey(label);
          const previous = sizes.get(key);

          sizes.set(key, {
            label,
            available: Boolean(
              v.available || previous?.available
            )
          });
        });

        const missing = orderedSizes(
          [...sizes.values()]
            .filter(s => !s.available)
            .map(s => s.label)
        );

        if (!missing.length) return;

        this.querySelector('.inn-size-message').textContent =
          cat[2]
            ? `Ne možeš naći svoj broj? Pogledaj sve ${cat[1]} u tvom broju:`
            : `Ne možeš naći svoju veličinu? Pogledaj sve ${cat[1]} u tvojoj veličini:`;

        const container = this.querySelector(
          '.inn-size-values'
        );

        missing.forEach(size => {
          const url = new URL(
            `${p.root}/${cat[0]}`,
            location.origin
          );

          url.searchParams.set('view', 'inn-size');
          url.searchParams.set('broj', size);
          url.searchParams.set(
            'spol',
            audience.join(',')
          );
          

          const preview = new URL(
            location.href
          ).searchParams.get('preview_theme_id');

          if (preview) {
            url.searchParams.set(
              'preview_theme_id',
              preview
            );
          }

          const a = element('a', '', size);

          a.href = url.pathname + url.search;

          a.setAttribute(
            'aria-label',
            `${cat[1]}, veličina ${size}, dostupni modeli`
          );

          container.append(a);
        });

        this.hidden = false;
      } catch (error) {
        console.warn(
          'INN veličine: nije moguće prikazati linkove.',
          error
        );
      }
    }
  }

  class SizeResults extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.grid = this.querySelector('.inn-size-grid');
      this.status = this.querySelector('.inn-size-status');
      this.retry = this.querySelector('.inn-size-retry');
      this.count = this.querySelector('.inn-size-count');
      this.params = new URL(location.href).searchParams;
      this.size = this.params.get('broj') || this.params.get('inn_size') || '';
      this.audience = (this.params.get('spol') || this.params.get('inn_group') || '')
        .split(',').filter(g => Object.hasOwn(groups, g));
      this.cardCache = new Map();
      this.requestId = 0;
      try {
        this.first = this.parseData(this, '[data-inn-results]');
        this.cat = categories.find(c => c[0] === this.first.handle);
        if (!this.cat || !this.grid) throw new Error('Nepodržana kolekcija.');
        this.pageSize = this.first.pageSize;
        this.cardCache.set(this.first.page, Promise.resolve(this.first));
        this.querySelector('.inn-size-audience').textContent = [
          this.size && 'Veličina: ' + this.size,
          this.audience.map(g => groups[g]).join(' / ')
        ].filter(Boolean).join(' · ') || 'Dostupni modeli';
        this.retry.addEventListener('click', () => this.showPage(this.requestedPage));
        this.setupControls();
        this.showPage(this.params.get('stranica'));
      } catch (error) {
        this.status.textContent = 'Prikaz trenutno nije dostupan. Pokušaj osvježiti stranicu.';
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.filterObserver?.disconnect();
    }
    filteredUrl(value) {
      const url = new URL(value, location.origin);
      ['inn_size', 'inn_group', 'inn_exclude', 'page', 'stranica', 'section_id'].forEach(k => url.searchParams.delete(k));
      url.searchParams.set('view', 'inn-size');
      if (this.size) url.searchParams.set('broj', this.size);
      else url.searchParams.delete('broj');
      if (this.audience.length) url.searchParams.set('spol', this.audience.join(','));
      else url.searchParams.delete('spol');
      const preview = this.params.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url;
    }
    pageUrl(page) {
      const url = this.filteredUrl(location.href);
      if (page > 1) url.searchParams.set('stranica', String(page));
      url.hash = '';
      return url;
    }
    filterLink(a) {
      const original = a.dataset.innOriginalHref || a.getAttribute('href');
      if (!original || original.startsWith('#')) return null;
      const target = new URL(original, location.origin);
      if (target.origin !== location.origin) return null;
      const group = a.closest('.filter-group');
      const heading = plain(group?.querySelector('h4')?.textContent || '');
      const label = a.textContent.trim();
      const isSize = /^(velicina|velicine|broj|size)$/.test(heading);
      const isAudience = /^(pol|spol|gender)$/.test(heading);
      const clear = /^(ocisti|clear|vidi sve|view all)$/.test(plain(label));
      const url = this.filteredUrl(isSize || isAudience ? location.href : target);
      if (isSize) {
        if (clear || sizeKey(label) === sizeKey(this.size)) url.searchParams.delete('broj');
        else url.searchParams.set('broj', label);
      } else if (isAudience) {
        const selected = Object.keys(groups).find(g => plain(groups[g]) === plain(label));
        if (!selected && !clear) return null;
        const values = clear ? [] : this.audience.includes(selected)
          ? this.audience.filter(g => g !== selected) : [...this.audience, selected];
        if (values.length) url.searchParams.set('spol', values.join(','));
        else url.searchParams.delete('spol');
      } else {
        const base = new URL(this.first.url, location.origin).pathname.replace(/\/$/, '');
        if (!(target.pathname === base || target.pathname.startsWith(base + '/'))) return null;
      }
      if (!url.searchParams.has('sort_by') && this.params.has('sort_by')) {
        url.searchParams.set('sort_by', this.params.get('sort_by'));
      }
      return url;
    }
    markFilters() {
      this.querySelectorAll('.filter-menu .filter-group').forEach(group => {
        const heading = plain(group.querySelector('h4')?.textContent || '');
        const sizeGroup = /^(velicina|velicine|broj|size)$/.test(heading);
        const audienceGroup = /^(pol|spol|gender)$/.test(heading);
        group.querySelectorAll('a[href]').forEach(a => {
          if (!a.dataset.innOriginalHref) a.dataset.innOriginalHref = a.getAttribute('href');
          const url = this.filterLink(a);
          if (url) a.href = url.pathname + url.search;
          if (!sizeGroup && !audienceGroup) return;
          const label = a.textContent.trim();
          const selected = sizeGroup ? Boolean(this.size && sizeKey(label) === sizeKey(this.size))
            : this.audience.some(g => plain(groups[g]) === plain(label));
          a.closest('li')?.classList.toggle('selected', selected);
          if (selected) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      });
    }
    setupControls() {
      const signal = this.abort.signal;
      document.addEventListener('click', event => {
        const a = event.target.closest?.('a');
        if (!a || !this.contains(a)) return;
        let url;
        if (a.closest('.filter-menu')) url = this.filterLink(a);
        else if (a.closest('inn-size-remove') && !a.matches('.active-facets__button-remove, .mobile-facets__clear')) url = this.filteredUrl(a.href);
        else if (a.dataset.innPage) url = this.pageUrl(Number(a.dataset.innPage));
        if (!url) return;
        a.href = url.pathname + url.search;
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (a.dataset.innPage) this.showPage(Number(a.dataset.innPage), 'push', true);
        else location.assign(url.href);
      }, { capture: true, signal });
      this.querySelectorAll('inn-size-form form').forEach(form => {
        form.addEventListener('submit', event => {
          event.preventDefault();
          this.submitFilters(form);
        });
        form.addEventListener('change', event => {
          if (event.target.name) this.submitFilters(form);
        });
      });
      this.querySelectorAll('[data-collection-grid-list]').forEach(button => {
        button.setAttribute('role', 'button');
        button.tabIndex = 0;
        const activate = () => {
          const list = button.dataset.collectionGridList === 'list';
          this.grid.classList.toggle('collection-template__product-list', list);
          this.grid.classList.toggle('collection-template__product-grid', !list);
          this.querySelectorAll('[data-collection-grid-list]').forEach(b => {
            b.classList.toggle('active', b === button);
            b.setAttribute('aria-pressed', String(b === button));
          });
        };
        button.addEventListener('click', activate);
        button.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(); }
        });
      });
      window.addEventListener('popstate', () => {
        this.showPage(new URL(location.href).searchParams.get('stranica'), 'none', true);
      }, { signal });
      this.markFilters();
      this.filterObserver = new MutationObserver(() => this.markFilters());
      this.querySelectorAll('.filter-menu').forEach(menu => this.filterObserver.observe(menu, { childList: true, subtree: true }));
    }
    submitFilters(form) {
      const url = this.filteredUrl(location.href);
      const values = new FormData(form);
      const names = new Set([...form.elements].map(el => el.name).filter(Boolean));
      names.forEach(name => url.searchParams.delete(name));
      for (const [name, value] of values) if (String(value) !== '') url.searchParams.append(name, value);
      location.assign(url.href);
    }
    matchingVariant(p) {
      if (category(p)?.[0] !== this.cat[0]) return null;
      if (this.audience.length && !this.audience.some(g => p.tags.map(plain).includes(g))) return null;
      const index = sizeIndex(p);
      if (this.size && index < 0) return null;
      return p.variants.find(v => v.available && (!this.size || sizeKey(v.options[index]) === sizeKey(this.size))) || null;
    }
    parseData(root, selector) {
      const payload = root.querySelector(selector);
      if (!payload) throw new Error('Nedostaje prikaz kolekcije.');
      const data = JSON.parse(payload.textContent);
      if (data.version !== 4 || !Array.isArray(data.products)) throw new Error('Potrebna je nova verzija datoteka.');
      if (selector === '[data-inn-results]') {
        const cards = root.querySelector('template[data-inn-items]')?.content;
        const map = new Map([...cards?.children || []].map(card => [String(card.dataset.innProduct), card.innerHTML]));
        data.products.forEach(p => { p.card = map.get(String(p.id)); });
      }
      return data;
    }
    async readData(url, selector) {
      const response = await fetch(url, {
        signal: AbortSignal.any([this.abort.signal, AbortSignal.timeout(20000)]),
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = this.parseData(doc, selector);
      if (data.handle !== this.first.handle) throw new Error('Pogrešna kolekcija.');
      return data;
    }
    async inBatches(values, callback) {
      const results = [];
      for (let i = 0; i < values.length; i += 3) {
        results.push(...await Promise.all(values.slice(i, i + 3).map(callback)));
      }
      return results;
    }
    async readIndexPage(page) {
      const url = this.filteredUrl(location.href);
      url.searchParams.set('view', 'inn-size-index');
      url.searchParams.set('page', String(page));
      const data = await this.readData(url, '[data-inn-index]');
      if (data.page !== page || data.offset !== (page - 1) * 250) throw new Error('Pogrešna stranica indeksa.');
      return data;
    }
    async buildIndex() {
      const first = await this.readIndexPage(1);
      const others = await this.inBatches(
        Array.from({ length: Math.max(0, first.pages - 1) }, (_, i) => i + 2),
        page => this.readIndexPage(page)
      );
      const seen = new Set();
      const matches = [];
      for (const data of [first, ...others]) {
        if (data.total !== first.total || data.pages !== first.pages) throw new Error('Kolekcija se promijenila.');
        data.products.forEach((p, index) => {
          if (!seen.has(p.id) && this.matchingVariant(p)) {
            seen.add(p.id);
            matches.push({ id: p.id, sourcePage: Math.floor((data.offset + index) / this.pageSize) + 1 });
          }
        });
      }
      if (this.first.total !== first.total) this.cardCache.clear();
      this.indexTotal = first.total;
      return matches;
    }
    async readCards(page) {
      if (!this.cardCache.has(page)) {
        const url = this.filteredUrl(location.href);
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.set('page', String(page));
        this.cardCache.set(page, this.readData(url, '[data-inn-results]').catch(error => {
          this.cardCache.delete(page);
          throw error;
        }));
      }
      const data = await this.cardCache.get(page);
      if (data.page !== page || data.total !== this.indexTotal || data.pageSize !== this.pageSize) {
        this.cardCache.delete(page);
        throw new Error('Kolekcija se promijenila.');
      }
      return data;
    }
    cardNode(p) {
      const variant = this.matchingVariant(p);
      if (!variant || typeof p.card !== 'string') throw new Error('Dostupnost se promijenila.');
      const item = element('div', 'collection-template__product-item col');
      item.innerHTML = p.card;
      const productPath = new URL(p.url, location.origin).pathname;
      item.querySelectorAll('a[href]').forEach(a => {
        const url = new URL(a.getAttribute('href'), location.origin);
        if (url.origin !== location.origin || url.pathname !== productPath) return;
        url.searchParams.set('variant', variant.id);
        const preview = this.params.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        a.href = url.pathname + url.search;
      });
      item.querySelectorAll('.price').forEach(price => {
        price.classList.toggle('price--on-sale', Boolean(variant.old));
        price.querySelectorAll('.price__regular .price-item--regular').forEach(el => { el.textContent = variant.price; });
        price.querySelectorAll('.price__sale .price-item--sale').forEach(el => { el.textContent = variant.price; });
        price.querySelectorAll('.price__sale .price-item--regular').forEach(el => { el.textContent = variant.old || ''; });
      });
      return item;
    }
    paginationParts(page, pages) {
      const numbers = new Set([1, pages]);
      const start = page <= 3 ? 1 : Math.max(1, page - 1);
      const end = page >= pages - 2 ? pages : Math.min(pages, Math.max(3, page + 1));
      for (let i = start; i <= end; i++) numbers.add(i);
      const parts = [];
      for (const number of [...numbers].sort((a, b) => a - b)) {
        const previous = parts.at(-1);
        if (typeof previous === 'number' && number - previous === 2) parts.push(previous + 1);
        else if (typeof previous === 'number' && number - previous > 2) parts.push('…');
        parts.push(number);
      }
      return parts;
    }
    renderPagination(page, total) {
      const pages = Math.max(1, Math.ceil(total / this.pageSize));
      this.querySelectorAll('[data-inn-pagination]').forEach(container => {
        container.hidden = pages <= 1;
        const nav = element('nav', 'pagination');
        nav.setAttribute('aria-label', 'Stranice proizvoda');
        const list = element('ul', 'pagination__list list-unstyled');
        const add = (target, text, label, current = false, arrow = '') => {
          const li = element('li');
          const link = target !== null && !current;
          const control = element(link ? 'a' : 'span', 'pagination__item' +
            (current ? ' pagination__item--current' : '') +
            (arrow ? ' pagination__item-arrow link motion-reduce' : ''), arrow ? undefined : text);
          if (label) control.setAttribute('aria-label', label);
          if (link) {
            const url = this.pageUrl(target);
            control.href = url.pathname + url.search;
            control.dataset.innPage = String(target);
          } else if (current) {
            control.setAttribute('aria-current', 'page');
            control.tabIndex = -1;
          } else if (arrow) {
            control.setAttribute('aria-disabled', 'true');
            li.setAttribute('disabled', '');
          } else li.className = 'inn-size-ellipsis';
          if (arrow) {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('class', 'svg-icon');
            svg.setAttribute('aria-hidden', 'true');
            const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
            use.setAttribute('href', '#arrow-' + arrow);
            svg.append(use);
            control.append(svg);
          }
          li.append(control);
          list.append(li);
        };
        add(page > 1 ? page - 1 : null, '', 'Prethodna stranica', false, 'left');
        this.paginationParts(page, pages).forEach(part => {
          if (typeof part === 'number') add(part, String(part), 'Stranica ' + part, part === page);
          else add(null, part, 'Preskočene stranice');
        });
        add(page < pages ? page + 1 : null, '', 'Sljedeća stranica', false, 'right');
        nav.append(list);
        container.replaceChildren(nav);
      });
    }
    async showPage(value, historyMode = 'replace', scroll = false) {
      const number = Number(value);
      const requested = Number.isSafeInteger(number) && number > 0 ? number : 1;
      this.requestedPage = requested;
      const requestId = ++this.requestId;
      this.retry.hidden = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = this.matches ? 'Učitavamo stranicu…' : 'Tražimo dostupne modele…';
      try {
        if (!this.indexPromise) this.indexPromise = this.buildIndex().catch(error => {
          this.indexPromise = null;
          throw error;
        });
        this.matches = await this.indexPromise;
        if (requestId !== this.requestId || this.abort.signal.aborted) return;
        const page = Math.min(requested, Math.max(1, Math.ceil(this.matches.length / this.pageSize)));
        const start = (page - 1) * this.pageSize;
        const visible = this.matches.slice(start, start + this.pageSize);
        const sourcePages = [...new Set(visible.map(p => p.sourcePage))];
        const batches = await this.inBatches(sourcePages, p => this.readCards(p));
        if (requestId !== this.requestId || this.abort.signal.aborted) return;
        const products = new Map(batches.flatMap(data => data.products.map(p => [p.id, p])));
        const nodes = visible.map(p => {
          const product = products.get(p.id);
          if (!product) throw new Error('Redoslijed proizvoda se promijenio.');
          return this.cardNode(product);
        });
        this.grid.replaceChildren(...nodes);
        this.currentPage = page;
        this.renderPagination(page, this.matches.length);
        const message = this.matches.length
          ? `Prikazano ${start + 1}–${start + visible.length} od ${this.matches.length} modela.`
          : 'Trenutno nema dostupnih modela za izabranu veličinu i filtere.';
        this.status.textContent = message;
        this.count.textContent = message;
        this.querySelectorAll('.mobile-facets__count').forEach(el => { el.textContent = this.matches.length + ' modela'; });
        const url = this.pageUrl(page);
        if (historyMode === 'push') history.pushState(null, '', url.pathname + url.search);
        else if (historyMode === 'replace') history.replaceState(null, '', url.pathname + url.search);
        while (this.cardCache.size > 12) this.cardCache.delete(this.cardCache.keys().next().value);
        if (scroll) {
          this.querySelector('#CollectionProductGrid').scrollIntoView({ block: 'start' });
          this.querySelector('[data-inn-pagination] [aria-current="page"]')?.focus({ preventScroll: true });
        }
      } catch (error) {
        if (requestId !== this.requestId || this.abort.signal.aborted) return;
        this.indexPromise = null;
        this.matches = null;
        this.cardCache.clear();
        this.status.textContent = 'Nismo uspjeli učitati stranicu. Pokušaj ponovo.';
        this.retry.hidden = false;
      } finally {
        if (requestId === this.requestId) this.grid.setAttribute('aria-busy', 'false');
      }
    }
  }

  customElements.define('inn-size-links', SizeLinks);
  customElements.define('inn-size-results', SizeResults);
})();